import {Component, OnInit} from '@angular/core';
import {HttpClient, HttpClientModule} from '@angular/common/http';
import { ApiService } from 'src/app/services/api-service/api.service';
import * as $ from 'jquery';




@Component({
  selector: 'app-page-backstage',
  templateUrl: './page-backstage.component.html',
  styleUrls: ['./page-backstage.component.scss']
})
export class PageBackstageComponent implements OnInit {

  private userID = 'e5ee107932aa4d34a0c219d66e645724';
  private accessToken = '64341211e0934419bab858ffb037447d';
  private photoAmount = 100;
  private apiUrl = 'https://api.instagram.com/v1/users/' + this.userID + '/media/recent';

  public bakstage: any[];


  private photos: any;

  // constructor (){}
  constructor(private apiService: ApiService ) {
    // this.photos = this.apiService.getPhotos().subscribe(price => console.log(price));
    // this.bakstage = this.apiService.instagram;
  
  }


  ngOnInit() {
  //   let userFeed = new Instafeed({
  //     get: 'user',
  //     userId: this.userID,
  //     limit: 12,
  //     resolution: 'standard_resolution',
  //     accessToken: this.accessToken,
  //     sortBy: 'most-recent',
  // });

  }

}
